import { render, staticRenderFns } from "./DichVuDiemDenList.vue?vue&type=template&id=544dd4ca"
import script from "./DichVuDiemDenList.vue?vue&type=script&lang=js"
export * from "./DichVuDiemDenList.vue?vue&type=script&lang=js"
import style0 from "./DichVuDiemDenList.vue?vue&type=style&index=0&id=544dd4ca&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports